/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgHdc32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        fill='#000'
        fillRule='evenodd'
        d='M16 13.25a2.75 2.75 0 100 5.5 2.75 2.75 0 000-5.5zM14.75 16a1.25 1.25 0 112.5 0 1.25 1.25 0 01-2.5 0z'
      />
      <path
        fill='#000'
        fillRule='evenodd'
        d='M16 6.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S21.385 6.25 16 6.25zM7.75 16c0-.436.034-.864.099-1.282l3.763-1.915a9.673 9.673 0 018.776 0l3.763 1.915a8.307 8.307 0 01.097 1.464 8.561 8.561 0 00-7.32 8.016 8.325 8.325 0 01-1.857 0 8.56 8.56 0 00-7.319-8.016A8.4 8.4 0 017.75 16zm3.182-4.534l-2.516 1.28a8.252 8.252 0 0115.168 0l-2.516-1.28a11.172 11.172 0 00-10.136 0zm13.135 6.269a7.063 7.063 0 00-5.608 6.142 8.264 8.264 0 005.608-6.142zm-10.526 6.142a7.063 7.063 0 00-5.608-6.142 8.264 8.264 0 005.608 6.142z'
      />
      <path
        fill='#000'
        fillRule='evenodd'
        d='M16 3.25C8.958 3.25 3.25 8.958 3.25 16S8.958 28.75 16 28.75 28.75 23.042 28.75 16 23.042 3.25 16 3.25zM4.75 16C4.75 9.787 9.787 4.75 16 4.75S27.25 9.787 27.25 16 22.213 27.25 16 27.25 4.75 22.213 4.75 16z'
      />
    </svg>
  );
}

export default SvgHdc32;
